import { identity } from "lodash";
import * as React from "react";

import { Stack, Typography } from "@mui/material";

import { Header } from "../../../components/atoms/Header";
import { UpdateFormTemplateProc } from "@/templates/FormTemplate";
import { colors } from "@/styles/constants";

export type KYCNotAvailableYet = {
  expressForm?: boolean;
  onContinue: () => void;
  onSectionClick: (section: string) => void;
  updateTemplate: UpdateFormTemplateProc;
};

export const KYCNotAvailableYet: React.FC<KYCNotAvailableYet> = ({
  expressForm,
  onContinue,
  onSectionClick,
  updateTemplate,
}) => {
  React.useEffect(() => {
    updateTemplate({
      currentSection: "kyc",
      onNext: onContinue,
      onSave: identity,
      onSectionClick: onSectionClick,
    });
  }, [onContinue, onSectionClick, updateTemplate]);

  return (
    <Stack rowGap={4}>
      <Header level={1} color={expressForm ? colors.accentTeal : undefined}>
        Not available yet.
      </Header>

      <Typography variant="body1">Please enter your details first.</Typography>
    </Stack>
  );
};
